import { render, staticRenderFns } from "./PcMapController.vue?vue&type=template&id=15473fe8&scoped=true&"
import script from "./PcMapController.vue?vue&type=script&lang=js&"
export * from "./PcMapController.vue?vue&type=script&lang=js&"
import style0 from "./PcMapController.vue?vue&type=style&index=0&id=15473fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15473fe8",
  null
  
)

export default component.exports